import { combineReducers } from "redux";
import authReducer from "./authReducers";
import errorReducer from "./errorReducers";
import searchReducer from "./searchReducers";
import successReducers from "./successReducers";
export default combineReducers({
  auth: authReducer,
  errors: errorReducer,
  search: searchReducer,
  success: successReducers
});
